/**
 * 오버레이(팝업·시트·전체 화면)가 떠 있을 때 휴대폰 뒤로가기의 뜻 — "배경 탭과 같게" (B2 결정 2026-10-27).
 *
 * - 닫히는 중: 소비만(아무 일 없음) — 닫힘 애니메이션 동안 뒤로가기가 아래 화면으로 새지 않게.
 * - 배경이 보이지 않는 전체 화면: X·닫기와 같음.
 * - 그 밖: 배경 탭을 눌렀을 때와 같은 반응(닫힘 / 흔들림 / 아무 일 없음).
 *
 * 각 오버레이 부품은 열린 순간부터 언마운트까지 acquireOverlay 로 등록하고, 핸들러에서 이 판단을 쓴다.
 */
export type OverlayBackdropReaction = "close" | "shake" | "none";

export type OverlayBackAction = OverlayBackdropReaction;

export type OverlayBackState = {
  /** 닫기가 이미 시작됐다(부모가 isOpen=false 로 바꿨거나, 닫기 요청을 보낸 뒤). */
  isClosing: boolean;
  /** 배경이 보이지 않는 전체 화면이면 true — 뒤로가기는 X·닫기와 같다. */
  isFullScreen?: boolean;
  /** 지금 배경(Dim)을 탭했을 때의 반응. */
  backdrop: OverlayBackdropReaction;
};

export const resolveOverlayBackAction = ({
  isClosing,
  isFullScreen = false,
  backdrop,
}: OverlayBackState): OverlayBackAction => {
  if (isClosing) return "none";
  if (isFullScreen) return "close";
  return backdrop;
};
